import { otto } from "../chunks/common-nexus-client-BxVeVD8v.mjs";
import { asExport } from "../chunks/common-core-client-BYCqsbss.mjs";
import { noop } from "../chunks/common-function-client-BVBvJr6Z.mjs";
const viewport = /*           */ asExport(otto, "viewport", {});
const currentBreakpoint = /*           */ asExport(
  viewport,
  "currentBreakpoint",
  {}
);
const isActiveBreakpoint = /*           */ asExport(
  viewport,
  "isActiveBreakpoint",
  noop
);
const getCurrentBreakpoint = /*           */ asExport(
  viewport,
  "getCurrentBreakpoint",
  noop
);
const currentOrientation = /*           */ asExport(
  viewport,
  "currentOrientation",
  {}
);
const isActiveOrientation = /*           */ asExport(
  viewport,
  "isActiveOrientation",
  noop
);
const getCurrentOrientation = /*           */ asExport(
  viewport,
  "getCurrentOrientation",
  noop
);
const getScrollbarWidth = /*           */ asExport(
  viewport,
  "getScrollbarWidth",
  noop
);
export {
  currentBreakpoint,
  currentOrientation,
  getCurrentBreakpoint,
  getCurrentOrientation,
  getScrollbarWidth,
  isActiveBreakpoint,
  isActiveOrientation,
  viewport
};
/*                                        */
